import * as React from 'react';
import { cn } from '@/lib/cn';

type Padding = 'none' | 'sm' | 'md' | 'lg';

const paddingMap: Record<Padding, string> = {
  none: 'p-0',
  sm: 'p-15',
  md: 'p-15',
  lg: 'p-25',
};

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: Padding;
  interactive?: boolean;
}

export function Card({
  className,
  padding = 'md',
  interactive = false,
  children,
  ...props
}: CardProps) {
  return (
    <div
      className={cn(
        'bg-raised border border-line-subtle',
        paddingMap[padding],
        interactive &&
          'hover:border-line-DEFAULT hover:shadow-hover cursor-pointer',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

Card.Header = function CardHeader({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('flex items-center justify-between mb-15', className)}
      {...props}
    />
  );
};

Card.Title = function CardTitle({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn('type-title-sm', className)} {...props} />;
};

Card.Body = function CardBody({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('', className)} {...props} />;
};

Card.Footer = function CardFooter({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('mt-20 pt-15 border-t border-line-subtle', className)}
      {...props}
    />
  );
};
